jQuery(document).ready(function ($) {
    // Global vars
    var windowWidth = 0,
        windowHeight = 0,
        scrollTop = 0,
        loading = true,
        body = $('body'),
        header = $('.header'),
        main = $('.main'),
        footer = $('.footer');

    /*====================================
     Window Events
     ====================================*/

    $(window).resize(function (event) {
        //Causes resize not to fire if the windows haven't actually changed (great for IE8)
        if (windowWidth != $(window).viewportWidth() || windowHeight != $(window).viewportHeight()) {
            windowWidth = $(window).viewportWidth(),
                windowHeight = $(window).viewportHeight();

            //Code goes here

            main.css('min-height', windowHeight - (header.outerHeight(true) + footer.outerHeight(true) ));

        }
    }).resize();

    /*====================================
     Document Events
     ====================================*/

    $(document).scroll(function (event) {
        scrollTop = $(document).scrollTop();
        if (scrollTop > 100) {
            //forces browser to chill out for a moment if the page just loaded
            setTimeout(function () {
                body.addClass('scrolled');
            }, loading ? 500 : 0);
        } else {
            body.removeClass('scrolled');
        }
    });
    //stops the browser loading delay
    setTimeout(function () {
        loading = false;
    }, 500);


    $('.waypoint').each(function (index, el) {
        var that = $(this);
        that.waypoint({
            handler: function (direction) {
                that.addClass('fire');
            },
            offset: that.data('offset') + '%'
        });
    });

    /**
     * ACF Profile Fields
     */
    $("#acf-field_5834a2551d7e6").prop('disabled', true);

    /**
     * Autodisplay form
     */
    if (top.activeForm) {
        location.hash =top.activeForm;
    }
    if (location.hash.length > 3) {
        var $link = $('a[href="' + location.hash + '"]');
        $link.click();
    }

    /**
     * On click of Espanol, translate to spanish
     */
    if (location.hash == '#googtrans(en|es)' || Cookies.get('googtrans'))
        $('.btn-translate').html('English');
    $('.btn-translate').on('click', function (e) {
        e.preventDefault();

        if (Cookies.get('googtrans')) {
            var parts = location.host.split('.'),
                dom = '';

            for (var i = parts.length - 2; i >= 0; i--) {
                dom = parts.slice(i).join('.');

                Cookies.set('googtrans', '', {expires: -1, path: '/', domain: dom});
                Cookies.set('googtrans', '', {expires: -1, path: '/', domain: '.' + dom});
            }

            Cookies.set('googtrans', '', { expires: -1, path: '/' });
            location.hash = "";
        } else {
            location.hash = 'googtrans(en|es)';
        }

        location.reload();
    });

    /** Ads slider/fader **/
    // $('.ads').slick({
    //     infinite: true,
    //     arrows: false,
    //     speed: 600, // 1 minute
    //     autoplay: true,
    //     fade: true,
    //     cssEase: 'linear'
    // });

    $('.mask-phone input, #acf-field_581b84c2970f4').inputmask(
        '(999) 999-9999',
        {
            'onincomplete':function() {
                $(this).val('');
            }
        }
    );
});


$(document).on('shown.bs.tab', function (e) {
    var target = $(e.target).attr("href");
    top.location = target;
});

//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function ($) {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    $.fn.viewport = function (options) {
        if (this.get(0) != window) {
            return {
                width: this.outerWidth(),
                height: this.outerHeight()
            };
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    };

    $.fn.viewportWidth = function (options) {
        if (this.get(0) != window) {
            return this.outerWidth();
        }
        return e[a + 'Width'];
    };

    $.fn.viewportHeight = function (options) {
        if (this.get(0) != window) {
            return this.outerHeight();
        }
        return e[a + 'Height'];
    };

    $.fn.filterByData = function (prop, val) {
        return
        this.filter(
            function () {
                return $(this).data(prop) == val;
            }
        );
    }

    ///////////////////////////////////////////////////////////////////
    //
    //
    $(function () {
        var $form = $('form.search-form');

        // $('.skills').select2();

        // FRESH AJAX SEARCH - CLEAR ALL RESULTS AND SEARCH FROM THE TOP

        $form.on('submit', function () {
            $('.search-summary').html(getSearchSummary());
            $('.start').val('0');
            getSearchResults();
            return false;
        });
        $form.on('change', function (e) {
            clearTimeout(window.searchSummaryTimeout);
            window.searchSummaryTimeout = setTimeout(function () {
                $form.trigger('submit');
            }, 500);
            return false;
        });
        $form.trigger('submit');
    });

    $(document).on('click', '.skill-has-children', function (event) {
        event.preventDefault();
        $(this).toggleClass('open');
    });

    // RESET SEARCH
    $(document).on('click', '.search-reset', function () {
        $('.search-form')[0].reset();
    });

    // RESET SEARCH
    $(document).on('reset', '.search-form', function (e) {
        $('.select2-container').select2('data', null);
        acf.fields.address_map.update(null, null, true);
        setTimeout(function () {
            $('.search-form').trigger('submit');
        }, 0);
    });
    // SEE MORE RESULTS
    $(document).on('click', 'a.view-more', function (e) {
        getSearchResults();
        return false;
    });

    /**
     * RETRIEVE SEARCH RESULTS FROM SERVER
     */
    function getSearchResults() {
        var $searchResults = $('.searcher-search-results'),
            $searchContainer = $('.searcher-container');

        $searchContainer.removeClass('none-exist more-exist');
        try {
            if (window.currentSearchRequest) {
                window.currentSearchRequest.abort();
            }
        } catch (ignore) {
        }

        var request = {
            method: 'POST',
            dataType: "json",
            url: acf.get('ajaxurl'),
            data: getSearchCriteria()
        };
        $searchResults.addClass('busy');
        window.currentSearchRequest = $.ajax(request).done(function (response) {
            if (!response.first) {
                $searchResults.html('');
            }
            $searchResults.append(response.html);
            $searchResults.removeClass('busy');
            $('.start').val(response.last);
            $searchContainer.toggleClass('more-exist', response.remaining > 0);
            $searchContainer.toggleClass('none-exist', !response.last > 0);
            $(document).trigger('ads_loaded');
        });
    }

    $(document).on('ads_loaded ready', function(){
		$('.ads:not(.slick-slider)').slick({
			infinite: true,
			arrows: false,
			speed: 60000, // 1 minute
			autoplay: true,
			fade: true,
			cssEase: 'linear'
		});
		var $ad=$('.ads-listing');
		var $insertAdPosition=$('.searcher-result:nth-child(4)');
		if ($insertAdPosition.length){
			$insertAdPosition.after($ad);
        }
    });

    /**
     * Returns a data package appropriate for the type of search. The type of search is determined by the type attribute of the form.search-form.
     * @returns {{action: string, miles, keywords, lat, lng, start: Number, types: string}}
     */
    function getSearchCriteria() {
        var $form = $('form.search-form'),
            searchType = $form.data('type'),
            jobTypeSelector = $('.job_type:checked').length == 0 ? '.job_type' : '.job_type:checked',
            skills = [],
            $skills = $('.skills :checked').each(function () {
                skills.push($(this).val())
            }),
            jobTypes = [],
            selectedJobTypes = $(jobTypeSelector).each(function () {
                jobTypes.push($(this).val())
            });

        if (searchType == 'jobs') {
            return {
                action: 'da_search_jobs',
                miles: $form.find('select.miles :selected').val(),
                keywords: $form.find('input.keywords').val(),
                lat: $form.find('.input-lat').val(),
                lng: $form.find('.input-lng').val(),
                start: parseInt($form.find('.start').val(), 10),
                types: jobTypes.join(',')
            };
        }

        if (searchType == 'workers') {
            return {
                action: 'da_search_workers',
                miles: $form.find('select.miles :selected').val(),
                keywords: $form.find('input.keywords').val(),
                lat: $form.find('.input-lat').val(),
                lng: $form.find('.input-lng').val(),
                start: parseInt($form.find('.start').val(), 10),
                skills: skills.join('~'),
                hasResume: $form.find('.has-resume').is(':checked') ? '1' : null
            };
        }
    }


    $(document).on('click', '.get-my-location', function () {
        try {
            navigator.geolocation.getCurrentPosition(function (position) {
                acf.fields.address_map.update(position.coords.latitude, position.coords.longitude, true);
                $('.search-form').trigger('change');
            })
        } catch (release) {
        }
    });

    /**
     * Returns a string such as "Showing all Part Time, Internship & Seasonal “keywords” jobs/workers located in “93612”"
     *
     */
    function getSearchSummary() {
        var types = [],
            searchType = $('form.search-form').data('type'),
            typesString = '',
            keywordsString = $.trim($('.keywords').val()),
            locationString = $.trim($('.search').val()),
            distanceString = parseInt($.trim($('.miles').val()), 10),
            hasResumeString = $('.has-resume').is(':checked') ? ' that have a resume' : '',
            skills = [],
            $skills = $('.skills :checked').each(function () {
                skills.push($(this).val())
            });

        $('input.job_type:checked').each(function () {
            types.push($(this).val());
        });

        if (types.length > 0 && types.length < $('input.job_type').length) {
            if (types.length == 1) {
                typesString = types.slice(0, 1).join();
            } else {
                typesString = types.slice(0, -1).join(', ') + ' & ' + types.slice(-1).join();
            }
        }

        if (typesString) {
            typesString += ' ';
        }

        if (keywordsString) {
            keywordsString += ' ';
        }

        if (skills.length) {
            typesString = skills.join(', ') + ' ';
        }

        if (locationString) {
            if (distanceString) {
                locationString = 'located within ' + distanceString + ' miles of "' + locationString + '"';
            } else {
                locationString = 'located near "' + locationString + '"';
            }
        }

        return "Showing all " + typesString + keywordsString + searchType + ' ' + locationString + hasResumeString;
    }


})(jQuery);